import palette from '../palette';

export default {
    dayLabel:{
        color: palette.colors.primary
    }
};
